import { render, staticRenderFns } from "./Career.vue?vue&type=template&id=7bcb4ef6&scoped=true&"
import script from "./Career.vue?vue&type=script&lang=js&"
export * from "./Career.vue?vue&type=script&lang=js&"
import style0 from "./Career.vue?vue&type=style&index=0&id=7bcb4ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcb4ef6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
